<template>
  <main>
    <v-toolbar style="background-color: #444; color: #fff; border-radius: 5px">
      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form @submit.prevent="handleSubmit">
      <formWrapper :validator="$v.form">
        <v-container>
          <v-row>
            <v-col cols="12">
              <locale-select
                v-if="isEdit"
                v-model="locale"
                @change="changeLocale"
              />
            </v-col>
            <v-col cols="12" md="6">
              <form-group
                :validator="$v.form.name"
                name="name"
                attribute="fields.name"
              >
                <template slot-scope="{ attrs, listeners }">
                  <v-text-field
                    clearable
                    type="text"
                    dense
                    v-bind="attrs"
                    v-on="listeners"
                    outlined
                    v-model="form.name"
                    :messages="$t('required')"
                  ></v-text-field>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12" md="6" v-if="!isEdit">
              <form-group name="feature_type" attribute="fields.feature_type">
                <template slot-scope="{ attrs, listeners }">
                  <v-autocomplete
                    chips
                    small-chips
                    :loading="featureTypesLoading"
                    clearable
                    v-bind="attrs"
                    v-on="listeners"
                    :items="feature_types"
                    item-text="name"
                    item-value="id"
                    dense
                    :label="$t('fields.feature_type')"
                    outlined
                    v-model="form.feature_type"
                  ></v-autocomplete>
                </template>
              </form-group>
            </v-col>
            <v-col cols="12">
              <v-btn
                :disabled="$v.form.$invalid"
                :loading="loadingButton"
                type="submit"
                class="primary"
                large
                block
                rounded
                >{{ $t("button.save") }}
                <v-icon>mdi-content-save</v-icon></v-btn
              >
            </v-col>
            <!-- :disabled="$v.form.$invalid" -->
          </v-row>
        </v-container>
      </formWrapper>
    </v-form>
  </main>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  minValue,
  maxValue,
  requiredIf
} from "vuelidate/lib/validators";
import { maxWords } from "@/utils/validate";
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";

export default {
  name: "CreateAndEdit",

  data() {
    return {
      featureTypesLoading: true,
      loadingButton: false,
      locale: this.locale,
      form: {
        name: "",
        feature_type: ""
      },
      feature_types: []
    };
  },
  computed: {
    formTitle() {
      if (this.$route.name === "create-feature") {
        return this.$t("heading.create_feature");
      } else {
        return this.$t("heading.edit_feature");
      }
    },
    isEdit() {
      if (this.$route.name === "create-feature") {
        return false;
      } else {
        return true;
      }
    }
  },
  mounted() {
    this.getFeatureTypes();
  },
  methods: {
    async getFeatureTypes() {
      const res = await IndexData({ reqName: `feature-types` });
      const { feature_types } = res.data;
      this.feature_types = feature_types;
      this.featureTypesLoading = false;
    },
    handleShowData(locale = this.locale) {
      ShowData({
        reqName: "features",
        param: this.$route.params.slug,
        locale
      }).then(res => {
        const { feature } = res.data;

        this.form = {
          name: feature.name
        };
      });
    },
    generateData() {
      const formData = new FormData();

      for (const key in this.form) {
        if (this.form[key] !== "") formData.append(key, this.form[key]);
      }
      if (this.isEdit) {
        formData.append("_method", "put");
        formData.append("locale", this.locale);
      }
      return formData;
    },
    onCreate() {
      StoreData({ reqName: "features", data: this.generateData() })
        .then(() => {
          this.$router.push("/features");
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    onUpdate() {
      UpdateData({
        reqName: "features",
        data: this.generateData(),
        param: this.$route.params.slug,
        locale: this.locale
      })
        .then(() => {
          this.$router.push("/features");
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    handleSubmit() {
      this.loadingButton = true;

      if (!this.isEdit) {
        // in case create
        this.onCreate();
      } else {
        // in case edit
        this.onUpdate();
      }
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(150)
      },
      feature_type: {
        required: requiredIf(function() {
          if (!this.isEdit) {
            return true;
          } else {
            return false;
          }
        })
      }
    }
  },

  watch: {
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true
    }
  }
};
</script>
